import React, { useEffect, useRef, useState } from "react"
import { Button, Card, Col, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, CardHeader, CardBody, Collapse, Row } from "reactstrap"
import { withTranslation } from "react-i18next"
import swal from "sweetalert"

// Import Editor
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

//Import Date Picker
import "react-datepicker/dist/react-datepicker.css"
import PropTypes from "prop-types"
import usePermission from "helpers/permission/usePermission"
import { connect } from "react-redux"
import {
  buscarPlanoContas,
  previewRecorrencia,
  editarLancamentoSerie, buscarContasPagarHoje, buscarContasPagarMes,
} from "store/auth/profile/actions"
import { apiBuscarFornecedoresPesquisa } from "helpers/backend_helper"
import moment from "moment"
import FormSelectCompany from "../../components/Common/form-select-company"
import FormInputText from "../../components/Common/form-input-text"
import FormInputDate from "../../components/Common/form-input-date"
import FormInputSelect from "../../components/Common/form-input-select"
import FormInputMoney from "../../components/Common/form-input-money"
import FormInputSwitch from "../../components/Common/form-input-switch"
import FormInputAsyncSelect from "../../components/Common/form-input-async-select"
import FormInputTypeNumber from "../../components/Common/form-input-type-number"
import RecorrenciaFields from "./lancamento-modal/recorrencia-fields"
import PreviewConfirmacaoDialog from "./lancamento-modal/preview-confirmacao-dialog"
import RecorrenciaInfoBanner from "./lancamento-modal/recorrencia-info-banner"
import EscopoDialog from "./lancamento-modal/escopo-dialog"
import ptBR from "date-fns/locale/pt-BR"
import { registerLocale, setDefaultLocale } from "react-datepicker"
import { removeHour } from "../../helpers/utils"
import Tooltip from "../../components/Common/tooltip"
registerLocale("ptBR", ptBR)
setDefaultLocale("ptBR")

const brazilMoment = (...args) => moment(...args)

// Envia o dia selecionado como meia-noite UTC (timezone 0), sem o offset local de Brasilia.
const toDataSemTimezone = d => (d ? moment(d).format("YYYY-MM-DD") + "T00:00:00.000Z" : null)

const FREQ_LABEL_MAP = { S: "semanal", Q: "quinzenal", M: "mensal", B: "bimestral", T: "trimestral", E: "semestral", A: "anual" }

const LancamentoModal = props => {
  const {
    despesa,
    isOpen,
    toggle,
    saveLancamento,
    companies,
  } = props
  const [inputValue, setInputValue] = useState() // utilizado no auto complete do fornecedor

  const [loja, setLoja] = useState()
  const [fornecedor, setFornecedor] = useState()
  const [notaEntrada, setNotaEntrada] = useState()
  const [emissao, setEmissao] = useState()
  const [vencimento, setVencimento] = useState()
  const [descricao, setDescricao] = useState()
  const [documento, setDocumento] = useState()
  const [valor, setValor] = useState()
  const [conta, setConta] = useState()
  const [contas, setContas] = useState()

  const [pagamento, setPagamento] = useState()
  const [multa, setMulta] = useState()
  const [juros, setJuros] = useState()
  const [desconto, setDesconto] = useState()
  const [contaPagamento, setContaPagamento] = useState()
  const [cheque, setCheque] = useState()
  const [impresso, setImpresso] = useState()
  const [reaberta, setReaberta] = useState()

  const [jurosDiario, setJurosDiario] = useState()
  const [multaMensal, setMultaMensal] = useState()
  const [descontoAteVencimento, setDescontoAteVencimento] = useState(false)
  const [descontoAntecipacao, setDescontoAntecipacao] = useState(false)
  const [observacao, setObservacao] = useState()
  const [company, setCompany] = useState("")

  const [opcoesAvancada, setOpcoesAvancada] = useState(false)

  const [tipo, setTipo] = useState("avulsa")
  const [recorrencia, setRecorrencia] = useState({
    frequencia: "M",
    regra_vencimento: "M",
    termina_em: "qtd",
    qtd_recorrencias: 12,
    data_fim: null,
    data_inicio: null,
    dia_semana: null,
  })
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewLoading, setPreviewLoading] = useState(false)
  // Só abre o preview quando solicitado nesta sessão — evita reabrir a partir
  // do previewRecorrenciaResult persistido (redux-persist) ao recarregar a tela.
  const previewSolicitadoRef = useRef(false)
  const [escopoDialogOpen, setEscopoDialogOpen] = useState(false)
  const [vencimentoOriginal, setVencimentoOriginal] = useState(null)

  const usePermissionInsert = usePermission('contasPagar_inserir')
  const usePermissionEdit = usePermission('contasPagar_editar')

  useEffect(() => {
    setCompany(despesa?.idEmpresa || company)
    setLoja(despesa?.loja)
    if (despesa?.fornec && despesa?.fornecedor) {
      setFornecedor({
        label: `${despesa.fornecedor.cnpj} - ${despesa.fornecedor.razaosocial}`,
        value: despesa.fornec,
      })
    } else {
      setFornecedor(null)
    }
    setNotaEntrada(despesa?.nota_entrada)
    setEmissao(
      despesa?.emissao
        ? brazilMoment(despesa?.emissao, "YYYY-MM-DD").toDate()
        : new Date()
    )
    setVencimento(
      despesa?.vencimento
        ? brazilMoment(despesa?.vencimento, "YYYY-MM-DD").toDate()
        : null
    )
    setVencimentoOriginal(
      despesa?.vencimento
        ? brazilMoment(despesa?.vencimento, "YYYY-MM-DD").toDate()
        : null
    )
    setPagamento(
      despesa?.data_pagamento
        ? brazilMoment(despesa?.data_pagamento, "YYYY-MM-DD").toDate()
        : null
    )
    setDescricao(despesa?.descricao)
    setDocumento(despesa?.documento)
    setValor(despesa?.valor_real || 0)
    setJurosDiario(despesa?.juros_diario_vlr || 0)
    setMultaMensal(despesa?.multa_mensal_vlr || 0)
    setDescontoAteVencimento(despesa?.desconto_ate_vencto === 1)
    setDescontoAntecipacao(despesa?.desconto_dia_antecipacao === 1)
    setObservacao(despesa?.obs)
    setConta(despesa?.codigo_conta)
    setMulta(despesa?.multa || 0)
    setJuros(despesa?.juros || 0)
    setDesconto(despesa?.desconto || 0)
    setContaPagamento(despesa?.conta_pagamento)
    setCheque(despesa?.cheque)
    setImpresso(
      despesa?.impresso
        ? brazilMoment(despesa?.impresso, "YYYY-MM-DD").toDate()
        : null
    )
    setReaberta(despesa?.reaberta)
    // reset tipo e recorrencia ao abrir modal
    setTipo("avulsa")
    setRecorrencia({ frequencia: "M", regra_vencimento: "M", termina_em: "qtd", qtd_recorrencias: 12, data_fim: null, data_inicio: null, dia_semana: null })
    setPreviewOpen(false)
    setPreviewLoading(false)
  }, [despesa])

  useEffect(() => {
    const opcoesCompany = (companies || []).filter(option => option.value)
    const companyValue = opcoesCompany.length > 0 ? opcoesCompany[0].value : undefined
    setCompany(companyValue)

    if (companyValue) {
      props.buscarPlanoContas({ company: companyValue })
    }
  }, [companies])

  useEffect(() => {
    if(company) {
      props.buscarPlanoContas({ company: company })
    }
  }, [company])

  useEffect(() => {
    if(Array.isArray(props.planoContas)) {
      const contas = props.planoContas.map(plano => ({ label: `${plano.codigo} - ${plano.descricao}`, value: plano.codigo }))
      setContas(contas)
    } else {
      setContas([])
    }
    return () => {
      setContas([])
    }
  }, [props.planoContas])

  useEffect(() => {
    if (!previewSolicitadoRef.current) return
    if (
      props.previewRecorrenciaResult !== undefined &&
      Array.isArray(props.previewRecorrenciaResult.datas)
    ) {
      previewSolicitadoRef.current = false
      setPreviewLoading(false)
      setPreviewOpen(true)
      // Se não for array, o erro é tratado pelo watcher de toastr em ContasPagar
    }
  }, [props.previewRecorrenciaResult])

  const buildRecorrenciaPayload = () => ({
    frequencia: recorrencia.frequencia,
    dia_semana: recorrencia.dia_semana || null,
    regra_vencimento: recorrencia.regra_vencimento || "M",
    data_inicio: toDataSemTimezone(recorrencia.data_inicio),
    data_fim: recorrencia.termina_em === "data" ? toDataSemTimezone(recorrencia.data_fim) : null,
    qtd_recorrencias: recorrencia.termina_em === "qtd" ? recorrencia.qtd_recorrencias : null,
  })

  const salvarLancamento = () => {
    const lancamento = despesa ? Object.assign({}, despesa) : {}
    lancamento.idEmpresa = company
    lancamento.loja = loja
    lancamento.fornec = fornecedor.value
    lancamento.nota_entrada = notaEntrada
    lancamento.emissao = emissao
    lancamento.vencimento = vencimento
    lancamento.data_pagamento = pagamento
    lancamento.descricao = descricao
    lancamento.documento = documento
    lancamento.valor_real = valor || 0
    lancamento.juros_diario_vlr = jurosDiario || 0
    lancamento.multa_mensal_vlr = multaMensal || 0
    lancamento.desconto_ate_vencto = descontoAteVencimento
    lancamento.desconto_dia_antecipacao = descontoAntecipacao
    lancamento.obs = observacao
    lancamento.codigo_conta = conta
    lancamento.multa = multa || 0
    lancamento.juros = juros || 0
    lancamento.desconto = desconto || 0
    lancamento.conta_pagamento = contaPagamento
    lancamento.cheque = cheque
    lancamento.impresso = impresso
    lancamento.reaberta = reaberta
    if (tipo === "recorrente" && !despesa?.id) {
      lancamento.vencimento = recorrencia.data_inicio
      lancamento.recorrencia = buildRecorrenciaPayload()
    }
    saveLancamento(lancamento)
  }

  const validateRecorrencia = () => {
    if (!recorrencia.frequencia) return props.t("contaspagar.recorrencia.frequencia.required")
    if (!recorrencia.data_inicio) return props.t("contaspagar.recorrencia.data_inicial.required")
    if (recorrencia.frequencia === "S" || recorrencia.frequencia === "Q") {
      if (!recorrencia.dia_semana) return props.t("contaspagar.recorrencia.dia_semana.required")
      const dow = moment(recorrencia.data_inicio).day() + 1
      if (dow !== recorrencia.dia_semana) return props.t("contaspagar.recorrencia.weekday_inconsistente")
    }
    if (recorrencia.termina_em === "data" && !recorrencia.data_fim) return props.t("contaspagar.recorrencia.termina_em.required")
    if (recorrencia.termina_em === "qtd" && (!recorrencia.qtd_recorrencias || recorrencia.qtd_recorrencias < 1 || recorrencia.qtd_recorrencias > 120)) return props.t("contaspagar.recorrencia.termina_em.qtd.range")
    if (recorrencia.termina_em === "data" && moment(recorrencia.data_fim).isBefore(recorrencia.data_inicio)) return props.t("contaspagar.recorrencia.termina_em.data.minima")
    return null
  }

  const onChangeTipo = novo => {
    if (novo === "avulsa" && tipo === "recorrente") {
      const algumPreenchido = recorrencia.data_inicio || recorrencia.data_fim
      // eslint-disable-next-line no-alert
      if (algumPreenchido && !confirm(props.t("contaspagar.recorrencia.confirmar_descartar"))) {
        return
      }
      setRecorrencia({ frequencia: "M", regra_vencimento: "M", termina_em: "qtd", qtd_recorrencias: 12, data_fim: null, data_inicio: null, dia_semana: null })
    }
    if (novo === "recorrente" && vencimento && !recorrencia.data_inicio) {
      setRecorrencia({ ...recorrencia, data_inicio: vencimento })
    }
    setTipo(novo)
  }

  // Data inicial (vencimento inicial) da recorrência — exibida na linha do tipo
  // de cobrança. Mantém o dia da semana sincronizado para frequências semanais.
  const onChangeDataInicioRecorrencia = date => {
    const update = { ...recorrencia, data_inicio: date }
    const showDiaSemana =
      recorrencia.frequencia === "S" || recorrencia.frequencia === "Q"
    if (showDiaSemana && date) {
      update.dia_semana = moment(date).day() + 1
    }
    setRecorrencia(update)
  }

  const save = () => {
    let valid = true
    valid = valid && (!!company)
    valid = valid && (!!loja)
    valid = valid && (!!fornecedor)
    valid = valid && (!!emissao)
    valid = valid && (!!valor)
    valid = valid && (!!conta)
    valid = valid && (!!descricao)
    valid = valid && (!!documento)
    if (tipo === "avulsa") valid = valid && (!!vencimento)

    if (!valid) {
      const divs = document.getElementsByName("validate-required")
      for (let i = 0; i < divs.length; i++) {
        divs[i].style.display = "block"
      }
      return
    }

    if (tipo === "recorrente") {
      const errMsg = validateRecorrencia()
      if (errMsg) {
        swal({ title: errMsg, icon: "error" })
        return
      }
      previewSolicitadoRef.current = true
      setPreviewLoading(true)
      props.previewRecorrencia(buildRecorrenciaPayload())
      return
    }

    if (despesa?.id && despesa?.id_recorrencia) {
      setEscopoDialogOpen(true)
      return
    }

    salvarLancamento()
  }

  const salvarLancamentoComEscopo = escopo => {
    if (escopo === "esta") {
      salvarLancamento()
      return
    }

    // futuras / todas: usa endpoint de série, body com bloco despesa (sem vencimento)
    const despesaPayload = {
      idEmpresa: company,
      loja: loja,
      fornec: fornecedor.value,
      nota_entrada: notaEntrada,
      emissao: emissao,
      descricao: descricao,
      documento: documento,
      valor_real: valor || 0,
      juros_diario_vlr: jurosDiario || 0,
      multa_mensal_vlr: multaMensal || 0,
      desconto_ate_vencto: descontoAteVencimento,
      desconto_dia_antecipacao: descontoAntecipacao,
      obs: observacao,
      codigo_conta: conta,
      multa: multa || 0,
      juros: juros || 0,
      desconto: desconto || 0,
      conta_pagamento: contaPagamento,
      cheque: cheque,
      impresso: impresso,
    }

    const body = { escopo, despesa: despesaPayload }
    if (escopo === "futuras") body.desde_id = despesa.id

    props.editarLancamentoSerie({ id_recorrencia: despesa.id_recorrencia, body })
    toggle()  // fecha o modal — ContasPagar reage ao result via toastr/refetch
  }

  const buscarFornecedoresPorNome = (inputValue, callback) => {
    if (!company) {
      callback([])
      return
    }
    return apiBuscarFornecedoresPesquisa({ empresaId: company, argumento: inputValue })
      .then(results => {
        const options = results.map(({ codigo, cnpj, razaosocial }) => {
          return { label: `${cnpj} - ${razaosocial}`, value: codigo };
        })
        if(fornecedor && fornecedor === despesa.fornec) {
          if(!options.some(option => option.value === fornecedor)) {
            options.unshift({ label: `${despesa.cnpj_fornecedor} - ${despesa.nome_fornecedor}`, value: despesa.fornec })
          }
        }
        callback(options)
      })
  }

  return (
    <React.Fragment>
      {despesa && (
        <Modal
          isOpen={isOpen}
          role="dialog"
          autoFocus={true}
          centered={true}
          tabIndex="-1"
          scrollable={true}
          size="xl"
          toggle={toggle}
        >
          <div className="modal-content">
            <ModalHeader toggle={toggle}>
              {despesa?.id
                ? props.t("contaspagar.modal.editar.titulo", { id: despesa.id })
                : props.t("contaspagar.modal.criar.titulo")}
              {despesa?.id && despesa?.recorrencia && (
                <span className="badge bg-info ms-2 align-middle">
                  <i className="mdi mdi-repeat me-1" />
                  {props.t("contaspagar.modal.editar.recorrencia", {
                    frequencia: props.t(
                      `contaspagar.recorrencia.frequencia.${
                        FREQ_LABEL_MAP[despesa.recorrencia.frequencia] ||
                        "mensal"
                      }`
                    ),
                    qtd: despesa.recorrencia.qtd_geradas || 0,
                  })}
                </span>
              )}
            </ModalHeader>
            <ModalBody>
              {despesa?.id &&
                despesa?.id_recorrencia &&
                despesa?.recorrencia && (
                  <RecorrenciaInfoBanner recorrencia={despesa.recorrencia} />
                )}
              <form>
                <div className="outer">
                  <div className="outer">
                    <div className="cp-form-grid">
                      {despesa?.id ? (
                        <React.Fragment>
                          <Row>
                            <Col md="12">
                              <FormSelectCompany
                                attribute="empresa"
                                description={props.t(
                                  "contaspagar.modal.criar.empresa"
                                )}
                                value={company}
                                setValue={value => {
                                  setCompany(value)
                                  setFornecedor(null)
                                  setConta(null)
                                  setContaPagamento(null)
                                }}
                                options={(companies || []).filter(c => c.value)}
                                required
                                disabled={!!despesa.id}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormInputDate
                                attribute="emissao"
                                description={props.t(
                                  "contaspagar.modal.criar.emissao"
                                )}
                                value={emissao}
                                setValue={setEmissao}
                                disabled={true}
                              />
                            </Col>
                            <Col md="6">
                              <FormInputDate
                                attribute="vencimento"
                                description={props.t(
                                  "contaspagar.modal.criar.vencimento"
                                )}
                                value={vencimento}
                                setValue={setVencimento}
                                required
                                disabled={!!pagamento}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormInputText
                                attribute="descricao"
                                description={props.t(
                                  "contaspagar.modal.criar.descricao"
                                )}
                                value={descricao}
                                setValue={setDescricao}
                                required
                                disabled={!!pagamento}
                              />
                            </Col>
                            <Col md="6">
                              <FormInputMoney
                                attribute="valor"
                                description={props.t(
                                  "contaspagar.modal.criar.valor"
                                )}
                                value={valor}
                                setValue={setValor}
                                required
                                disabled={!!pagamento}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormInputSelect
                                attribute="centro_custo"
                                description={props.t(
                                  "contaspagar.modal.criar.centro_custo"
                                )}
                                value={conta}
                                setValue={setConta}
                                options={contas || []}
                                required
                                disabled={!!pagamento}
                              />
                            </Col>
                            <Col md="6">
                              <FormInputAsyncSelect
                                attribute="fornecedor"
                                description={props.t(
                                  "contaspagar.modal.criar.fornecedor"
                                )}
                                value={fornecedor}
                                setValue={setFornecedor}
                                loadOptions={buscarFornecedoresPorNome}
                                dependencyKey={company}
                                noOptionsMessage={company ? undefined : props.t("fornecedor.pesquisa.sem_empresa")}
                                disabled={!!pagamento}
                                required
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormInputSelect
                                attribute="centro_custo_pagamento"
                                description={props.t(
                                  "contaspagar.modal.criar.centro_custo_pagamento"
                                )}
                                value={contaPagamento}
                                setValue={setContaPagamento}
                                options={contas || []}
                                disabled={true}
                              />
                            </Col>
                            <Col md="6">
                              <FormInputDate
                                attribute="data_pagamento"
                                description={props.t(
                                  "contaspagar.modal.criar.data_pagamento"
                                )}
                                value={pagamento}
                                setValue={setPagamento}
                                disabled={true}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormInputTypeNumber
                                attribute="loja"
                                description={props.t(
                                  "contaspagar.modal.criar.loja"
                                )}
                                value={loja}
                                setValue={setLoja}
                                required
                                disabled={!!pagamento}
                              />
                            </Col>
                            <Col md="6">
                              <FormInputText
                                attribute="documento"
                                description={props.t(
                                  "contaspagar.modal.criar.documento"
                                )}
                                value={documento}
                                setValue={setDocumento}
                                required
                                disabled={!!pagamento}
                              />
                            </Col>
                          </Row>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {companies?.length > 1 && (
                            <Row>
                              <Col md="6">
                                <FormSelectCompany
                                  attribute="empresa"
                                  description={props.t(
                                    "contaspagar.modal.criar.empresa"
                                  )}
                                  value={company}
                                  setValue={value => {
                                    setCompany(value)
                                    setFornecedor(null)
                                    setConta(null)
                                    setContaPagamento(null)
                                  }}
                                  options={(companies || []).filter(
                                    c => c.value
                                  )}
                                  required
                                  disabled={!!despesa.id}
                                />
                              </Col>
                            </Row>
                          )}

                          <Row>
                            <Col md="6">
                              <FormGroup className="mb-4">
                                <label className="cp-field-label">
                                  {props.t(
                                    "contaspagar.modal.criar.tipo.label"
                                  )}
                                </label>
                                <div className="d-flex align-items-center">
                                  <span
                                    className={`me-2 ${
                                      tipo === "avulsa"
                                        ? "fw-semibold text-primary"
                                        : "text-muted"
                                    }`}
                                  >
                                    {props.t(
                                      "contaspagar.modal.criar.tipo.avulsa"
                                    )}
                                  </span>
                                  <input
                                    type="checkbox"
                                    id="tipo-recorrente-switch"
                                    name="tipo-recorrente-switch"
                                    switch="none"
                                    checked={tipo === "recorrente"}
                                    onChange={(e) => {
                                      if(e.target.checked) {
                                        onChangeTipo("recorrente")
                                      } else {
                                        onChangeTipo("avulsa")
                                      }
                                    }}
                                  />
                                  <label
                                    htmlFor="tipo-recorrente-switch"
                                    className="mb-0"
                                    data-on-label=""
                                    data-off-label=""
                                  />
                                  <span
                                    className={`ms-2 ${
                                      tipo === "recorrente"
                                        ? "fw-semibold text-primary"
                                        : "text-muted"
                                    }`}
                                  >
                                    {props.t(
                                      "contaspagar.modal.criar.tipo.recorrente"
                                    )}
                                  </span>
                                </div>
                              </FormGroup>
                            </Col>
                            <Col md="6">
                              {tipo === "recorrente" ? (
                                <FormInputDate
                                  attribute="data_inicio"
                                  description={props.t(
                                    "contaspagar.modal.criar.vencimento_inicial"
                                  )}
                                  value={recorrencia.data_inicio}
                                  setValue={onChangeDataInicioRecorrencia}
                                  required
                                />
                              ) : (
                                <FormInputDate
                                  attribute="vencimento"
                                  description={props.t(
                                    "contaspagar.modal.criar.vencimento"
                                  )}
                                  value={vencimento}
                                  setValue={setVencimento}
                                  required
                                  disabled={!!pagamento}
                                />
                              )}
                            </Col>
                          </Row>

                          {tipo === "recorrente" && (
                            <RecorrenciaFields
                              value={recorrencia}
                              onChange={setRecorrencia}
                            />
                          )}

                          <Row>
                            <Col md="6">
                              <FormInputText
                                attribute="descricao"
                                description={props.t(
                                  "contaspagar.modal.criar.descricao"
                                )}
                                value={descricao}
                                setValue={setDescricao}
                                required
                                disabled={!!pagamento}
                              />
                            </Col>
                            <Col md="6">
                              <FormInputMoney
                                attribute="valor"
                                description={props.t(
                                  "contaspagar.modal.criar.valor"
                                )}
                                value={valor}
                                setValue={setValor}
                                required
                                disabled={!!pagamento}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormInputSelect
                                attribute="centro_custo"
                                description={props.t(
                                  "contaspagar.modal.criar.centro_custo"
                                )}
                                value={conta}
                                setValue={setConta}
                                options={contas || []}
                                required
                                disabled={!!pagamento}
                              />
                            </Col>
                            <Col md="6">
                              <FormInputAsyncSelect
                                attribute="fornecedor"
                                description={props.t(
                                  "contaspagar.modal.criar.fornecedor"
                                )}
                                value={fornecedor}
                                setValue={setFornecedor}
                                loadOptions={buscarFornecedoresPorNome}
                                dependencyKey={company}
                                noOptionsMessage={company ? undefined : props.t("fornecedor.pesquisa.sem_empresa")}
                                disabled={!!pagamento}
                                required
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col md="6">
                              <FormInputTypeNumber
                                attribute="loja"
                                description={props.t(
                                  "contaspagar.modal.criar.loja"
                                )}
                                value={loja}
                                setValue={setLoja}
                                required
                                disabled={!!pagamento}
                              />
                            </Col>
                            <Col md="6">
                              <FormInputText
                                attribute="documento"
                                description={props.t(
                                  "contaspagar.modal.criar.documento"
                                )}
                                value={documento}
                                setValue={setDocumento}
                                required
                                disabled={!!pagamento}
                              />
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </div>

                    <FormInputText
                      attribute="observacao"
                      description={props.t(
                        "contaspagar.modal.criar.observacao"
                      )}
                      value={observacao}
                      setValue={setObservacao}
                    />

                    <div id="accordion">
                      <Card className="mb-1">
                        <CardHeader className="p-3" id="headingOne">
                          <h6 className="m-0 font-14">
                            <span
                              onClick={() => {
                                setOpcoesAvancada(!opcoesAvancada)
                              }}
                              style={{ cursor: "pointer" }}
                              className="text-dark "
                            >
                              {props.t("contaspagar.modal.criar.avancado")}
                            </span>
                          </h6>
                        </CardHeader>
                        <Collapse isOpen={opcoesAvancada}>
                          <Card>
                            <CardBody>
                              <FormInputTypeNumber
                                attribute="nota_entrada"
                                description={props.t(
                                  "contaspagar.modal.criar.avancado.nota_entrada"
                                )}
                                value={notaEntrada}
                                setValue={setNotaEntrada}
                                disabled={!!pagamento}
                              />

                              <FormInputMoney
                                attribute="juros_diarios"
                                description={props.t(
                                  "contaspagar.modal.criar.avancado.juros_diarios"
                                )}
                                value={jurosDiario}
                                setValue={setJurosDiario}
                                disabled={!!pagamento}
                              />

                              <FormInputMoney
                                attribute="multa_mensal"
                                description={props.t(
                                  "contaspagar.modal.criar.avancado.multa_mensal"
                                )}
                                value={multaMensal}
                                setValue={setMultaMensal}
                                disabled={!!pagamento}
                              />

                              <FormInputSwitch
                                attribute="desconto_vencimento"
                                description={props.t(
                                  "contaspagar.modal.criar.avancado.desconto_vencimento"
                                )}
                                value={descontoAteVencimento}
                                setValue={setDescontoAteVencimento}
                                trueValue={true}
                                falseValue={false}
                                disabled={!!pagamento}
                              />

                              <FormInputSwitch
                                attribute="desconto_antecipacao"
                                description={props.t(
                                  "contaspagar.modal.criar.avancado.desconto_antecipacao"
                                )}
                                value={descontoAntecipacao}
                                setValue={setDescontoAntecipacao}
                                trueValue={true}
                                falseValue={false}
                                disabled={!!pagamento}
                              />

                              {despesa.id && (
                                <FormInputMoney
                                  attribute="multa"
                                  description={props.t(
                                    "contaspagar.modal.criar.avancado.multa"
                                  )}
                                  value={multa}
                                  setValue={setMulta}
                                  disabled={!!pagamento}
                                />
                              )}

                              {despesa.id && (
                                <FormInputMoney
                                  attribute="juros"
                                  description={props.t(
                                    "contaspagar.modal.criar.avancado.juros"
                                  )}
                                  value={juros}
                                  setValue={setJuros}
                                  disabled={!!pagamento}
                                />
                              )}

                              {despesa.id && (
                                <FormInputMoney
                                  attribute="desconto"
                                  description={props.t(
                                    "contaspagar.modal.criar.avancado.desconto"
                                  )}
                                  value={desconto}
                                  setValue={setDesconto}
                                  disabled={!!pagamento}
                                />
                              )}

                              {despesa.id && (
                                <FormInputText
                                  attribute="cheque"
                                  description={props.t(
                                    "contaspagar.modal.criar.avancado.cheque"
                                  )}
                                  value={cheque}
                                  setValue={setCheque}
                                  disabled={!!pagamento}
                                />
                              )}

                              {despesa.id && (
                                <FormInputDate
                                  attribute="impresso"
                                  description={props.t(
                                    "contaspagar.modal.criar.avancado.impresso"
                                  )}
                                  value={impresso}
                                  setValue={setImpresso}
                                  disabled={!!pagamento}
                                />
                              )}

                              {despesa.id && (
                                <FormGroup className="mb-4" row>
                                  <Label
                                    htmlFor="reaberta"
                                    className="col-form-label col-lg-2"
                                  >
                                    {props.t(
                                      "contaspagar.modal.criar.reaberturas"
                                    )}
                                  </Label>
                                  <Col lg="10" className="col-form-label">
                                    {props.t(
                                      "contaspagar.modal.criar.reaberturas.contagem",
                                      { n: reaberta || 0 }
                                    )}
                                  </Col>
                                </FormGroup>
                              )}
                            </CardBody>
                          </Card>
                        </Collapse>
                      </Card>
                    </div>
                  </div>
                </div>
              </form>
            </ModalBody>
            <ModalFooter>
              <Button
                type="submit"
                color="primary"
                disabled={
                  (!despesa.id && !usePermissionInsert) ||
                  (despesa && !usePermissionEdit)
                }
                onClick={save}
              >
                {props.t("contaspagar.modal.criar.botao.salvar")}
              </Button>
              <Button
                type="button"
                color="secondary"
                className="ms-2"
                onClick={toggle}
              >
                {props.t("contaspagar.modal.criar.botao.fechar")}
              </Button>
            </ModalFooter>
          </div>
        </Modal>
      )}

      <PreviewConfirmacaoDialog
        isOpen={previewOpen}
        datas={
          Array.isArray(props.previewRecorrenciaResult?.datas)
            ? props.previewRecorrenciaResult.datas
            : []
        }
        valor={new String(valor || "0").replaceAll(",", ".")}
        regra={buildRecorrenciaPayload()}
        loading={previewLoading}
        onCancel={() => setPreviewOpen(false)}
        onConfirm={() => {
          setPreviewOpen(false)
          salvarLancamento()
        }}
      />

      <EscopoDialog
        isOpen={escopoDialogOpen}
        vencimentoMudou={
          vencimentoOriginal &&
          vencimento &&
          moment(vencimentoOriginal).format("YYYY-MM-DD") !==
            moment(vencimento).format("YYYY-MM-DD")
        }
        onCancel={() => setEscopoDialogOpen(false)}
        onConfirm={escopo => {
          setEscopoDialogOpen(false)
          salvarLancamentoComEscopo(escopo)
        }}
      />
    </React.Fragment>
  )
}

LancamentoModal.propTypes = {
  t: PropTypes.func,
  toggle: PropTypes.func,
  saveLancamento: PropTypes.func,
  isOpen: PropTypes.bool,
  despesa: PropTypes.object,
  previewRecorrenciaResult: PropTypes.any,
  previewRecorrenciaLoading: PropTypes.bool,
  previewRecorrencia: PropTypes.func,
  editarLancamentoSerie: PropTypes.func,
  buscarPlanoContas: PropTypes.func,
  planoContas: PropTypes.array,
}

const mapStateToProps = state => {
  const {
    fornecedores,
    fornecedoresLoading,
    planoContas,
    planoContasLoading,
    previewRecorrenciaResult,
    previewRecorrenciaLoading,
  } = state.Profile
  return {
    fornecedores,
    fornecedoresLoading,
    planoContas,
    planoContasLoading,
    previewRecorrenciaResult,
    previewRecorrenciaLoading,
  }
}

export default connect(mapStateToProps, {
  buscarPlanoContas,
  previewRecorrencia,
  editarLancamentoSerie,
})(withTranslation()(LancamentoModal))
